import classnames from 'classnames'

import NextIcon from '../../../icons/next.inline.svg'
import PrevIcon from '../../../icons/prev.inline.svg'
import ChevronIcon from '../../chevronIcon/ChevronIcon'
import Icon from '../../icon'
import styles from '../custom-swiper.module.scss'
import { ArrowProps, ARROW_COLOR } from '../types/custom-swiper.types'

import btnStyles from './arrow.module.scss'

export const PreviousArrow = (props: ArrowProps) => (
  <button
    key={props.id}
    id={props.id}
    className={classnames(props.className, props.isChevronIcon && !props.isVertical && btnStyles.chevPrevButton)}
    aria-label={props.ariaLabel}
    onClick={props.onClick}
    disabled={props.disabled}
    style={{ height: props.isVertical ? '10px' : 'unset' }}
  >
    {props.isChevronIcon ? (
      <ChevronIcon
        className={classnames(props.isVertical ? btnStyles.vertical : btnStyles.horizontal, btnStyles.prev)}
        isVisible={props.disabled}
        isIconWithBG={props.isIconWithBG}
      />
    ) : (
      <Icon
        iconSvg={PrevIcon}
        className={classnames(styles.navIcon, {
          [styles.navIcon__white]: ARROW_COLOR.WHITE === props.arrowColor,
          [styles.navIcon__disabled]: props.disabled,
        })}
      />
    )}
  </button>
)

export const NextArrow = (props: ArrowProps) => (
  <button
    id={props.id}
    className={classnames(props.className, props.isChevronIcon && !props.isVertical && btnStyles.chevNextButton)}
    aria-label={props.ariaLabel}
    onClick={props.onClick}
    disabled={props.disabled}
    style={{ height: props.isVertical ? '1rem' : 'unset' }}
  >
    {props.isChevronIcon ? (
      <ChevronIcon
        className={classnames(props.isVertical ? btnStyles.vertical : btnStyles.horizontal, btnStyles.next)}
        isVisible={props.disabled}
        isIconWithBG={props.isIconWithBG}
      />
    ) : (
      <Icon
        iconSvg={NextIcon}
        className={classnames(styles.navIcon, {
          [styles.navIcon__white]: ARROW_COLOR.WHITE === props.arrowColor,
          [styles.navIcon__disabled]: props.disabled,
        })}
      />
    )}
  </button>
)
